"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.escapeKey = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _last = _interopRequireDefault(require("unmutable/lib/last"));

var _push = _interopRequireDefault(require("unmutable/lib/push"));

var _rest = _interopRequireDefault(require("unmutable/lib/rest"));

var _update = _interopRequireDefault(require("unmutable/lib/update"));

var _pipeWith = _interopRequireDefault(require("unmutable/lib/util/pipeWith"));

var escapeKey = function escapeKey(key) {
  return key.replace(/([^\w])/g, "%$1");
};

exports.escapeKey = escapeKey;
var DEFAULT_PARCELID_DATA = {
  id: ["^"],
  path: ["^"]
};

var ParcelId = function ParcelId() {
  var _this = this;

  var parcelIdData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_PARCELID_DATA;
  (0, _classCallCheck2.default)(this, ParcelId);
  (0, _defineProperty2.default)(this, "_id", void 0);
  (0, _defineProperty2.default)(this, "_path", void 0);
  (0, _defineProperty2.default)(this, "_create", function (data) {
    return new ParcelId(data);
  });
  (0, _defineProperty2.default)(this, "key", function () {
    return (0, _last.default)()(_this._path);
  });
  (0, _defineProperty2.default)(this, "id", function () {
    return _this._id.join(".");
  });
  (0, _defineProperty2.default)(this, "path", function () {
    return (0, _rest.default)()(_this._path);
  });
  (0, _defineProperty2.default)(this, "push", function (key, isElement) {
    var escapedKey = escapeKey(key);
    var escapeAndPush = isElement ? (0, _push.default)(key) : (0, _push.default)(escapedKey);
    return (0, _pipeWith.default)(_this.toJS(), (0, _update.default)('id', escapeAndPush), (0, _update.default)('path', (0, _push.default)(key)), _this._create);
  });
  (0, _defineProperty2.default)(this, "pushModifier", function (modifierTypeId) {
    return (0, _pipeWith.default)(_this.toJS(), (0, _update.default)('id', (0, _push.default)("~".concat(modifierTypeId))), _this._create);
  });
  (0, _defineProperty2.default)(this, "toJS", function () {
    return {
      id: _this._id,
      path: _this._path
    };
  });
  this._id = parcelIdData.id;
  this._path = parcelIdData.path;
};

exports.default = ParcelId;